var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createElement, memo, useMemo, useEffect, useState, useRef } from '@max/max';
import View from '@hfe/max-view';
import login from '@nibfe/mkt-user-api';
import { navigateTo } from '@max/meituan-uni-navigate';
import { COUPON_STATUS, getStatus, throttle } from './utils/index';
import { preSendCoupon, sendCoupon } from './api/index';
import AutoImage from './components/AutoImage';
import LoadingView from '@max/leez-loading-view';
import { getJumpUrlByEnv } from './utils/envUtils';
import './index.scss';
import { getAppType, getBuildExtParas } from './utils/buildExtraInfo';
import { ReserveStatus } from './constant';
const MyComponent = (props) => {
    var _a;
    const { imageConfig, toastConfig, jumpConfig, bizLine, _LXReport, _runtimeInfo, styleConfig, _communication, _uiInteractionAPI } = props;
    const { toast } = _uiInteractionAPI || {};
    const { mvReport, mcReportWithTag } = _LXReport;
    const { queryParams, pageId } = _runtimeInfo;
    const { hotelchannel = -999 } = queryParams || {};
    const source = (_a = queryParams === null || queryParams === void 0 ? void 0 : queryParams.src) !== null && _a !== void 0 ? _a : '-999';
    const { canReceiveImage, receiveImage, outReceiveImage, startImage, endImage, usedImage, receiveImageLink } = imageConfig;
    const { receivedSuccess, receivedIneligibility, receivedCompleted, receiveFail, clickStep, riskControl, receiveMuch, ratelimit, endToast, startToast } = toastConfig;
    const campaignKey = useMemo(() => { var _a; return ((_a = props === null || props === void 0 ? void 0 : props.campaignKey) === null || _a === void 0 ? void 0 : _a.campaignKey) || (props === null || props === void 0 ? void 0 : props.campaignKey) || ""; }, [props.campaignKey]);
    const userInfo = useRef({});
    const [imageUrl, setImageUrl] = useState('');
    const [status, setStatue] = useState('');
    const jumpUrl = useRef('');
    const [isLoading, setLoading] = useState(false);
    const [extraInfo, setExtraInfo] = useState({});
    const reserveStatus = useRef(ReserveStatus.NoReserve);
    /**
     * 根据「倒计时预约」的预约按钮触发领券
     */
    useEffect(() => {
        const callback = ({ isReserveSuccess }) => {
            reserveStatus.current = isReserveSuccess ? ReserveStatus.ReserveSuccess : ReserveStatus.ReserveFail;
            onClick();
        };
        _communication === null || _communication === void 0 ? void 0 : _communication.on("countdownReserveGetCoupons", callback);
        return () => {
            _communication === null || _communication === void 0 ? void 0 : _communication.off("countdownReserveGetCoupons", callback);
        };
    }, []);
    useEffect(() => {
        var _a;
        if (window && !window.hasH5GuardInit) {
            (_a = window === null || window === void 0 ? void 0 : window.H5guard) === null || _a === void 0 ? void 0 : _a.init({
                xhrHook: true,
                fetchHook: true,
                domains: ['cube.meituan.com', 'cube.dianping.com'],
                forceKNBSign: false,
                whitePaths: ['throne-hfe.meituan.com/api/throne', 'i.c.waimai.test.sankuai.com/aaa'],
                geo: false
            });
            window.hasH5GuardInit = true;
        }
        dataInit();
    }, []);
    const containerStyle = {
        width: '100%',
        height: '100%'
    };
    const containerInnerStyle = {
        width: '100%'
    };
    if (styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.customWidth) {
        containerStyle.width = `${styleConfig.width}rpx`;
        containerInnerStyle.widthRpx = styleConfig.width;
    }
    if (styleConfig === null || styleConfig === void 0 ? void 0 : styleConfig.customHeight) {
        containerStyle.height = `${styleConfig.height}rpx`;
        containerInnerStyle.heightRpx = styleConfig.height;
    }
    const dataInit = () => __awaiter(void 0, void 0, void 0, function* () {
        var _b;
        const buildExtParams = getBuildExtParas();
        const extParams = yield buildExtParams();
        setExtraInfo(extParams);
        if (!((_b = userInfo.current) === null || _b === void 0 ? void 0 : _b.userId)) {
            const userParam = yield login.getUserInfo();
            userInfo.current = userParam;
        }
        preSendCoupon({
            campaignKeys: campaignKey,
            userId: userInfo.current.userId || '12345',
            pageId: !pageId || pageId === 'unknown' ? '' : pageId,
            extraInfoMap: extParams,
            appType: getAppType()
        }, (result) => {
            var _a, _b;
            const { data, code } = (result === null || result === void 0 ? void 0 : result.data) || {};
            if (!(result === null || result === void 0 ? void 0 : result.data) || code !== 0 || (data === null || data === void 0 ? void 0 : data.length) === 0) {
                if (window === null || window === void 0 ? void 0 : window.inEditor) {
                    setImageUrl(outReceiveImage);
                }
                return;
            }
            if (data.length > 0) {
                const allStatus = [];
                data.forEach((item) => {
                    allStatus.push(item.code);
                });
                let status = getStatus(allStatus);
                setStatue(status);
                jumpUrl.current = (_b = (_a = data === null || data === void 0 ? void 0 : data[0]) === null || _a === void 0 ? void 0 : _a.extend) === null || _b === void 0 ? void 0 : _b.couponJumpUrl;
                switch (status) {
                    case COUPON_STATUS.NOT_START:
                        setImageUrl(startImage);
                        break;
                    case COUPON_STATUS.ALREADY_END:
                        setImageUrl(endImage);
                        break;
                    case COUPON_STATUS.ALREADY_USE:
                        setImageUrl(usedImage);
                        break;
                    case COUPON_STATUS.NO_STOCK:
                        setImageUrl(outReceiveImage);
                        break;
                    case COUPON_STATUS.ALREADY_SEND:
                        setImageUrl(receiveImage);
                        break;
                    case COUPON_STATUS.UNUSED:
                        setImageUrl(receiveImageLink);
                        break;
                    default:
                        setImageUrl(canReceiveImage);
                }
                mvReport('b_daodian_lowcode_0c6830ms_mv', {
                    valLab: {
                        area_title: '抢券模块',
                        secret: campaignKey,
                        source: source,
                        status: status,
                        custom: {
                            hotel_channel: hotelchannel,
                            click_biz_line: bizLine || -999
                        }
                    }
                });
            }
        });
    });
    const loadEnd = () => {
        dataInit();
        setLoading(false);
    };
    // 锚点跳转函数
    const jumpToComponent = (componentId) => {
        // 使用正确的方式获取util对象 - 从_uiInteractionAPI中获取
        const util = (_uiInteractionAPI === null || _uiInteractionAPI === void 0 ? void 0 : _uiInteractionAPI.util) || _uiInteractionAPI;
        try {
            // 根据组件ID获取真实的anchorKey
            const anchorKey = util.anchor.getAnchorKeyByModuleId(componentId);
            // 执行锚点跳转
            util.anchor.scrollToAnchor({
                anchorKey: anchorKey,
                offset: 0
            });
        }
        catch (error) {
            console.error('锚点跳转失败:', error.message);
        }
    };
    const onClick = throttle(() => __awaiter(void 0, void 0, void 0, function* () {
        var _c;
        const reserveText = reserveStatus.current === ReserveStatus.ReserveSuccess ? "预约成功" : reserveStatus.current === ReserveStatus.ReserveFail ? "预约失败" : "";
        setLoading(true);
        if (!((_c = userInfo.current) === null || _c === void 0 ? void 0 : _c.userId)) {
            const res = yield login.login();
            userInfo.current = res;
        }
        const { token, userId, uuid } = userInfo.current || {};
        mcReportWithTag('b_daodian_lowcode_ke2h8r59_mc', {
            valLab: {
                area_title: '抢券模块',
                secret: campaignKey,
                source: source,
                status: _getStatus(status),
                custom: {
                    hotel_channel: hotelchannel,
                    click_biz_line: bizLine
                }
            }
        });
        switch (status) {
            case COUPON_STATUS.CAN_RECEIVE:
                yield sendCoupon({
                    campaignKeys: campaignKey,
                    userId: userId || '12345',
                    pageId: !pageId || pageId === 'unknown' ? '' : pageId,
                    token: token,
                    uuid: uuid,
                    cityId: '',
                    realCityId: '',
                    extend: extraInfo,
                    appType: getAppType()
                }, (res) => {
                    const resData = res === null || res === void 0 ? void 0 : res.body;
                    const resCode = resData === null || resData === void 0 ? void 0 : resData.code;
                    switch (resCode) {
                        case 0:
                            toast.show({
                                content: reserveText + receivedSuccess
                            });
                            break;
                        case 2003:
                            {
                                // 红包异常
                                let toastMsg = receiveFail;
                                let codeArr = [];
                                for (const i in resData.data) {
                                    const item = resData.data[i];
                                    switch (item.code) {
                                        case 2005:
                                            codeArr.push(item.code);
                                            break;
                                        case 2006:
                                        case 2009:
                                            codeArr.push(item.code);
                                            break;
                                        case 2010:
                                            codeArr.push(item.code);
                                            break;
                                        case 2023:
                                            codeArr.push(item.code);
                                            break;
                                        case 8000:
                                            codeArr.push(item.code);
                                            break;
                                        default:
                                            break;
                                    }
                                }
                                // 未过用户规则
                                if (codeArr.indexOf(2010) > -1) {
                                    toastMsg = receivedIneligibility;
                                }
                                // 今日券已发完
                                if (codeArr.indexOf(2006) > -1 || codeArr.indexOf(2009) > -1) {
                                    toastMsg = receivedCompleted;
                                }
                                // 领取上限
                                if (codeArr.indexOf(2005) > -1) {
                                    toastMsg = receiveMuch;
                                }
                                // 话费券未绑定手机号
                                if (codeArr.indexOf(2023) > -1) {
                                    toastMsg = '领取失败，先绑定手机号再来领取吧';
                                }
                                // 参与人数过多文案
                                if (codeArr.indexOf(8000) > -1) {
                                    const randomNum = Math.floor(Math.random() * 4);
                                    toast.show({
                                        content: reserveText + ratelimit[randomNum]
                                    });
                                }
                                toast.show({
                                    content: reserveText + toastMsg
                                });
                            }
                            break;
                        case 2001:
                        case 2002:
                            toast.show({
                                content: reserveText + riskControl
                            });
                            break;
                        // 风控异常带提示语
                        case 1003:
                            toast.show({
                                content: reserveText + receivedIneligibility
                            });
                            break;
                        default:
                            toast.show({
                                content: reserveText + receiveFail
                            });
                            break;
                    }
                    loadEnd();
                });
                break;
            case COUPON_STATUS.ALREADY_SEND:
            case COUPON_STATUS.UNUSED:
                if ((jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.jumpType) === 'anchor' && jumpConfig.componentId) {
                    // 锚点跳转
                    jumpToComponent(jumpConfig.componentId);
                }
                else if ((jumpConfig === null || jumpConfig === void 0 ? void 0 : jumpConfig.jumpType) === 'url') {
                    // URL跳转，使用环境判断
                    const targetUrl = getJumpUrlByEnv(jumpConfig, jumpUrl.current);
                    if (targetUrl) {
                        navigateTo({
                            url: targetUrl,
                            _web: {
                                miniProgramNative: true
                            }
                        }).catch(err => {
                            console.log(err);
                        });
                    }
                }
                else {
                    // 兜底：使用接口返回的URL
                    if (jumpUrl.current) {
                        navigateTo({
                            url: jumpUrl.current,
                            _web: {
                                miniProgramNative: true
                            }
                        }).catch(err => {
                            console.log(err);
                        });
                    }
                }
                loadEnd();
                break;
            case COUPON_STATUS.ALREADY_END:
                toast.show({
                    content: reserveText + endToast
                });
                loadEnd();
                break;
            case COUPON_STATUS.NOT_START:
                toast.show({
                    content: reserveText + startToast
                });
                loadEnd();
                break;
            case COUPON_STATUS.NOT_PASS_USER_RULE:
                toast.show({
                    content: reserveText + receivedIneligibility
                });
                loadEnd();
                break;
            case COUPON_STATUS.NO_STOCK:
                toast.show({
                    content: reserveText + receivedCompleted
                });
                loadEnd();
                break;
            default:
                toast.show({
                    content: reserveText + receiveFail
                });
                loadEnd();
        }
    }), clickStep);
    const _getStatus = (status) => {
        switch (status) {
            case COUPON_STATUS.NOT_START:
                return 1;
            case COUPON_STATUS.ALREADY_END:
            case COUPON_STATUS.NO_STOCK:
                return 5;
            case COUPON_STATUS.UNUSED:
                return 3;
            case COUPON_STATUS.ALREADY_USE:
            case COUPON_STATUS.ALREADY_SEND:
                return 4;
            default:
                return 5;
        }
    };
    return <View className="multistate-redpacket" style={containerStyle} onClick={() => {
            if (!isLoading)
                onClick();
        }}>

      <AutoImage className="multistate-redpacket-box" styles={containerInnerStyle} uri={imageUrl || ''}/>
      <LoadingView x-if={isLoading} level={'medium'} className='auto-image-loading'/>
    </View>;
};
export default memo(MyComponent);
